import { useMount } from 'react-use'
import { useNavigate } from 'react-router'
import { useNFCSState } from 'modules/nfcs/hooks/useNFCSState'

import { PageLoader } from 'shared/ui/layout/PageLoader'

import type { SuccessData } from 'modules/pools/ui/FormBorrow'
import * as links from 'modules/router/links'

type Props = {
  successData: SuccessData
}

export function RouteBorrowSentRedirect({ successData }: Props) {
  const { risk } = useNFCSState()
  const { borrowedAsset } = successData.formValues
  const navigate = useNavigate()

  useMount(() => {
    const doRedirect = () => {
      if (!risk || !borrowedAsset) {
        navigate(links.borrow)
        return
      }
      navigate(links.borrowSent(successData.tx.hash, successData.loanIdx), {
        state: {
          asset: successData.formValues.borrowedAsset,
          principal: successData.formValues.amount,
        },
      })
    }
    doRedirect()
  })

  return <PageLoader />
}
